import { Component, EventEmitter, Output, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Helper } from "src/app/core/helpers/helper";

@Component({
  selector: "app-delete-modal",
  templateUrl: "./delete-modal.component.html",
  styleUrl: "./delete-modal.component.scss",
  standalone: false
})
export class DeleteModalComponent {
  index!: number;
  centeredModalRef: any;
  detail!: any;

  @ViewChild("deletemodal", { static: true }) deletemodal!: TemplateRef<any>;
  @Output() deleteDataEvent = new EventEmitter();

  constructor(public modalService: NgbModal, public helper: Helper) {}

  /**
   * Opens the delete modal dialog with the provided data and index.
   *
   * @param data The data to be passed to the modal.
   * @param index The index of the item to be deleted.
   */
  openModal(data: any = null, index: number = -1): void {
    this.detail = data;
    this.index = index;
    this.centeredModalRef = this.modalService.open(this.deletemodal, { centered: true, backdrop: "static" });
  }

  /**
   * Emits the delete event with the index or detail of the item to be deleted.
   */
  deleteData(): void {
    this.helper.showBtnLoader[1] = true;
    if (this.index !== -1) {
      this.deleteDataEvent.emit(this.index);
    } else {
      this.deleteDataEvent.emit(this.detail);
    }
  }

  /**
   * Closes the currently open modal dialog.
   */
  closeModal(): void {
    this.helper.showBtnLoader[1] = false;
    this.index = -1;
    this.detail = null;
    this.centeredModalRef.close();
    this.centeredModalRef = null; // Reset the modal reference
  }
}
